import React from 'react';
import { FormattedMessage } from 'react-intl';
import Clickable from '../clickable/Clickable';
import styles from './summary.module.scss';

const Summary = (props) => {
  const { data, tags, handleStatusFilter, enable_initial_review } = props;
  return (
    <>
      <div className={styles.datasources}>
        {data && tags && tags?.map(tag => Object.keys(data)?.map((ele) => {
          if (String(tag[1]) === String(ele)) {
            return (
              <div className={styles.column}>
                <h2 className={styles.pending_training} style={{ color: tag[3] }}>
                {!enable_initial_review && data?.reviewed && tag[1] === 'pending_approval'? data[ele] + data?.reviewed : data[ele]|| 0}
                </h2>
                <span className={styles.pending_training}>
                  <FormattedMessage
                    tagName="p"
                    id="module.id"
                    defaultMessage={tag[0]}
                  />
                </span>
                <Clickable
                  className={styles.active}
                  onClick={() => handleStatusFilter(tag[0])}
                >
                  <FormattedMessage
                    id="inspections.list.view"
                    defaultMessage="View"
                  />
                </Clickable>
              </div>
            );
          }
          return null;
        }))}
      </div>
    </>

  );
};

export default Summary;
